
import React from "react";
import { Ship } from "lucide-react";
import OceanMileStoneTracking from "./OceanMilestoneTracking";

function OceanEventLine({
  billOfLadingUpdates,
  selectedContainer1,
  selectedContainer,
  containerDataUpdate,
  firstAndLast,
}: {
  billOfLadingUpdates: any;
  selectedContainer1: any;
  selectedContainer: any;
  containerDataUpdate: any;
  firstAndLast: any;
}) {
  const filteredContainers =
    selectedContainer === "All"
      ? containerDataUpdate
      : containerDataUpdate.filter(
          (container: {}) =>
            Object.keys(container)[0] === selectedContainer
        );

  return (
    <div className="lg:col-span-5 col-span-12">
      <div className="whiteBox whiteBoxCustom trackpadding timelineMainBoxOcean">
        <div className="old_dashboard_title text-center">
          <h1 className="text-2xl text-gray-700 mt-[-15px] mb-[10px]">
            Events Timeline
          </h1>
        </div>
        <div className="trackNewScroll">
          {selectedContainer1 !== "Container" && (
            <div className="RoadMapscroll">
              <OceanMileStoneTracking
                ports={billOfLadingUpdates?.ports || []}
                firstAndLast={firstAndLast}
              />
            </div>
          )}

          {selectedContainer1 === "Container" && (
            <div>
              <div className="paddingo">
                <div className="timelineMainBox">
                  {filteredContainers.map((container: any) => {
                    const containerNumber = Object.keys(container)[0];

                    // ✅ handle both "traking" (typo) and "tracking" (correct)
                    const trackingData =
                      container[containerNumber]?.tracking ??
                      container[containerNumber]?.traking;

                    // ✅ safe fallback if still undefined
                    const ports: any[] = trackingData?.ports || [];

                    return (
                      <React.Fragment key={containerNumber}>
                        <div className="whiteBox00">
                          <div className="RoadMapscroll">
                            {selectedContainer === "All" && (
                              <div className="mt-2 mb-5 px-2 py-2 bg-gray-100 text-black rounded-lg flex items-center allContainer">
                                <Ship />
                                <p className="ml-2">{containerNumber}</p>
                              </div>
                            )}
                            <OceanMileStoneTracking
                              ports={ports}
                              firstAndLast={firstAndLast}
                            />
                          </div>
                        </div>
                      </React.Fragment>
                    );
                  })}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default OceanEventLine;